<template>
    <div class="d-flex">
        <v-btn
            v-for="item in items"
            :key="item.href"
            class="ma-1"
            small
            fab
            color="secondary"
            v-bind="btnProps"
            :href="item.href"
            target="_blank"
        >
            <v-icon>{{ item.icon }}</v-icon>
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "Socials",

    props: {
        btnProps: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            items: [
                {
                    href: "https://www.facebook.com/KingSoundReinforcement",
                    icon: "mdi-facebook",
                },
                {
                    href: "https://instagram.com/kingsoundreinforcement",
                    icon: "mdi-instagram",
                },
                {
                    href: "mailto:info@kingsr.com",
                    icon: "mdi-email",
                },
                {
                    href: "https://www.youtube.com/channel/UC4LZ2r17Phn-xa2jbTUyGTw",
                    icon: "mdi-youtube",
                },
                {
                    href: "https://twitter.com/KingsrUK",
                    icon: "mdi-twitter",
                },
                {
                    href: "https://vimeo.com/kingsoundreinforcement",
                    icon: "mdi-vimeo",
                },
            ],
        };
    },
};
</script>

<style scoped></style>
